import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getDesktopRedirectPath,
  isDesktopApp,
  isDesktopBlockedPath,
} from "../../../config/desktopApp";

export default function DesktopRouteGuard() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isDesktopApp()) {
      return;
    }

    if (isDesktopBlockedPath(location.pathname)) {
      navigate(getDesktopRedirectPath(), { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
}
